<template>
    <div>
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Library</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            About us
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cmn-section about-us-breadcrumb p-0">
            <img
                src="/maincss/images/about-us-banner2x.jpg"
                alt="about-us-image"
            />

            <div class="about-us-content pt-0">
                <div class="container">
                    <h1>About us</h1>
                    <p>We’re about you and everything you love!</p>
                </div>
            </div>
        </section>

        <section class="cmn-section about-us-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p>
                            Welcome to Imprint City, where we believe that every
                            person deserves to have a unique imprint on the
                            world.
                        </p>

                        <p>
                            Founded in Meridian, Idaho over 20 years ago, our
                            mission is to empower individuals and businesses to
                            leave their mark by providing high-quality custom
                            merchandise, promotional products, and branding
                            services. We understand that your brand is more than
                            just a logo; it's a reflection of who you are and
                            what you stand for. Your brand’s first impression
                            can make or break a sell. We truly help our clients,
                            Print, Promote and Profit!
                        </p>
                        <p>
                            At Imprint City, we take pride in our ability to
                            bring your vision to life. We’ve invested heavily in
                            our web technology and integration with other
                            systems to enhance your experience and improve our
                            communication. This is an ongoing process. Expect
                            continual improvement with time!
                        </p>
                        <p>
                            Our team of experienced designers and branding
                            experts work with you every step of the way to
                            ensure that your ideas are brought to fruition.
                            Whether you're looking to print custom apparel,
                            promote your business with promotional products, or
                            profit from complete branding solutions, we've got
                            you covered.
                        </p>
                        <p>
                            <b>In-House Screen Printing -</b> We also offer
                            embroidery services in-house as well as embroidery
                            digitizing (artwork) services. We run several of the
                            latest Tajima multi-head, 15-needle embroidery
                            machines allowing us to ensure that your logos sew
                            super clean and detailed.
                        </p>
                        <p>
                            <b>In-House Embroidery -</b> Our in-house screen
                            print department utilizes multiple automatic and
                            manual presses, giving us the flexibility to manage
                            the quality and speed of production on small to very
                            large volume orders.
                        </p>
                        <p>
                            <b>Promotional Products -</b> Put your logo on
                            literally tens of thousands of different types of
                            promotional items. We are constantly adding new
                            items to our website.
                        </p>
                        <p>
                            <b>24hourT-shirts -</b> We offer a 24-hour t-shirt
                            printing service, so you can have your custom shirts
                            in hand in no time. Get up to 500 White t-shirts
                            with up to 4 imprint colors printed within 24 hours.
                        </p>
                        <p>
                            <b>Company Stores & Team Stores -</b> We offer
                            company Stores & Team stores on our own platform, to
                            aid your group or team in ordering individually but
                            benefiting from bulk pricing.
                        </p>
                        <p>
                            <b>In-House Paper Printing Services -</b>
                            Additionally, we offer full-color paper printing
                            services, including flyers, brochures, and business
                            cards, to help you promote your brand in print.
                        </p>
                        <p>
                            Our commitment to excellence is evident in
                            everything we do, from the quality of our products
                            to the level of customer service we provide. We
                            believe in building long-lasting relationships with
                            our clients, and we strive to exceed their
                            expectations at every turn.
                        </p>
                        <p>
                            Thank you for choosing Imprint City as your partner
                            in leaving your mark on the world. We look forward
                            to working with you!
                        </p>
                        <p><b>Giving Back - FanRaise </b></p>
                        <p>
                            We also believe in giving back to our community,
                            which is why we offer fundraising opportunities for
                            schools and teams. We can help your organization
                            raise funds while outfitting your team with
                            high-quality uniforms and gear that show your pride
                            and spirit.
                        </p>
                        <p>
                            Other fundraisers take a large portion of the funds
                            you generated. At FanRaise, except for credit card
                            fees, we give it all back in cash and in custom high
                            quality apparel brands. Outfit your team and coaches
                            in custom gear with funds that would normally go to
                            the other guys' sales rep.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "AboutUs",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
    }
};
</script>
